import React from 'react';
import {
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { useFQAdminContext } from 'Views/Page/Content/Templates/FQAdminPanel/FQAdminContext';
import { TypeSelectorOption } from './TypeSelectorOption';

const TypeSelector = ({ resource }) => {
  const { lozengeRelationshipNames } = useFQAdminContext();

  return (
    <FDStack spacing={2} justifyContent={'center'} wrap>
      {lozengeRelationshipNames.map((relationshipName) => (
        <TypeSelectorOption resource={resource} relationshipName={relationshipName} />
      ))}
    </FDStack>
  );
};

TypeSelector.propTypes = {
  resource: PropTypes.object.isRequired,
};

export { TypeSelector };
